















import {
  nextTick,
  onBeforeUnmount,
  onMounted,
  ref,
  watch
} from '@vue/composition-api';
import { useWorkFlow } from '../../composables';
import { useNodesInitialized } from '../../composables/useNodesInitialized';
import WorkflowNodeWrapper from '../../components/nodes/WorkflowNodeWrapper.vue';
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'NodeRenderer',

  components: {
    WorkflowNodeWrapper
  },

  setup() {
    const { getNodes, updateNodeDimensions, emits } = useWorkFlow();

    const nodesInitialized = useNodesInitialized();

    const resizeObserver = ref<ResizeObserver>();

    watch(
      nodesInitialized,
      isInit => {
        if (isInit) {
          nextTick(() => {
            emits.nodesInitialized(getNodes.value);
          });
        }
      },
      { immediate: true }
    );

    onMounted(() => {
      resizeObserver.value = new ResizeObserver(entries => {
        const updates = entries.map(entry => {
          const id = entry.target.getAttribute('data-id') as string;

          return {
            id,
            nodeElement: entry.target as HTMLDivElement,
            forceUpdate: true
          };
        });

        nextTick(() => updateNodeDimensions(updates));
      });
    });

    onBeforeUnmount(() => resizeObserver.value?.disconnect());

    return {
      getNodes,
      resizeObserver
    };
  }
});
